import React, { useCallback, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

// `formGroup` is accepted for compatibility; the reactive form's group-level
// markAsTouched() it used to call never showed any field error
const useReCaptcha = (formGroup = null) => {
  const [disable, setDisable] = useState(true);
  const recaptcha = useRef();

  const onChange = useCallback(() => {
    setDisable(false);
  }, [setDisable]);

  const onExpired = useCallback(() => {
    setDisable(true);
  }, [setDisable]);

  const reCaptchaUI = (
    <ReCAPTCHA
      ref={recaptcha}
      onChange={onChange}
      onExpired={onExpired}
      sitekey={import.meta.env.REACT_APP_SITE_KEY}
    />
  );

  return { disable, reCaptchaUI, value: recaptcha.current?.getValue() };
};

export default useReCaptcha;
